import { Box, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { IoBagAddSharp } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'
import Business from '../../../../../../api/db/Business'
import { selectUserPropsState } from '../../../../../../store/features/user'
import { ValidatedButton, ValidatedForm, ValidatedTextInput } from '../../../../../organisms/validation/admin'

const initialValues= {
  shop_name: "",
}


const validationSchema = Yup.object().shape({
  shop_name: Yup.string().required().label("shop_name"),
})

export default function AddNewShopForm({onSubmit, onSubmitFail}: {onSubmit: (returned:any)=>void, onSubmitFail: (reaseon?:string)=>void}) {

    const [isLoading, setIsLoading] = useState(false)
    const user_id = useSelector(selectUserPropsState)?.uid


    const handleOnSubmit = async ({shop_name}: {shop_name:string})=>{

        try {

            setIsLoading(true)
            const new_shop = await Business.createShop(shop_name, user_id!)
            setIsLoading(false)
            onSubmit(new_shop)
            
        } catch (error) {
            setIsLoading(false)
            onSubmitFail()
            throw error
        }
        
    }

  return (
        <ValidatedForm
            onSubmit={handleOnSubmit}
            initialValues={initialValues}
            validationSchema={validationSchema}
        >

          <Box
          >
              <Stack 
                  direction="row"
                  sx={{width: "100%", marginBottom: "1rem"}}
                  spacing={2}
              >
                  <Stack sx={{width: "100%"}}>
                      <Typography variant="subtitle2" color="grey.500">Shop name</Typography>
                      <ValidatedTextInput name="shop_name" type="text" placeholder='Eg. Osu Branch' />
                  </Stack>
              </Stack>

              <Box
                  sx={{marginTop: "1.5rem", display: "flex", justifyContent: "flex-end"}}
              >
                  <ValidatedButton 
                      startIcon={<IoBagAddSharp />} 
                      variant="contained" 
                      color="secondary" 
                      disableElevation={true}
                      loading={isLoading}
                  >
                      <Typography  color="primary" sx={{fontSize:"13px"}} >Create shop</Typography>
                  </ValidatedButton>
              </Box>

          </Box>
          
        </ValidatedForm>
  )
}
